// import "./CSS_styles/skills3d.css";

// const skills = [
//   "Java",
//   "React JS",
//   "JavaScript",
//   "Python",
//   "SQL",
//   "C++",
//   "TypeScript",
//   "PyTorch",
//   "LLMs",
//   "RAG",
//   "Agentic AI",
//   "HuggingFace",
//   "LangChain",
//   "NoSQL",
//   "Node.js",
//   "Three.js / WebGL",
//   "Go",
//   "Spring Boot",
//   "GraphQL",
//   "Docker",
//   "Kubernetes",
//   "Kafka",
//   "GCP",
//   "AWS",
//   "CSS",
//   "Rest APIs",
//   "Redis",
//   "Cassandra",
//   "PostgreSQL",
//   "GitHub",
// ];

// export default function Skills3D() {
//   return (
//     <section className="skills3d-section" data-section="skills">
//       <div className="skills3d-shell">
//         <div className="skills3d-header">
          
//           <h2 className="skills3d-title">SKILLS</h2>
          
//         </div>

//         <div className="skills3d-console">
//           <div className="skills3d-grid">
//             {skills.map((skill) => (
//               <button key={skill} className="skill3d-tile" type="button">
//                 <span className="skill3d-face">
//                   <span className="skill3d-label">{skill}</span>
//                 </span>
//               </button>
//             ))}
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// }
import "./CSS_styles/skills3d.css";
import { useRef } from "react";

const skills = [
  "Java",
  "React JS",
  "JavaScript",
  "Python",
  "SQL",
  "C++",
  "TypeScript",
  "PyTorch",
  "LLMs",
  "RAG",
  "Agentic AI",
  "HuggingFace",
  "LangChain",
  "NoSQL",
  "Node.js",
  "Three.js / WebGL",
  "Go",
  "Spring Boot",
  "GraphQL",
  "Docker",
  "Kubernetes",
  "Kafka",
  "GCP",
  "AWS",
  "CSS",
  "Rest APIs",
  "Redis",
  "Cassandra",
  "PostgreSQL",
  "GitHub",
];

const notes = [
  261.63, // C4
  293.66, // D4
  329.63, // E4
  349.23, // F4
  392.0,  // G4
  440.0,  // A4
  493.88, // B4
  523.25, // C5
];

export default function Skills3D() {
  const audioContextRef = useRef(null);

  const playPianoTone = (frequency) => {
    if (!audioContextRef.current) {
      audioContextRef.current = new (window.AudioContext || window.webkitAudioContext)();
    }

    const audioContext = audioContextRef.current;
    const now = audioContext.currentTime;

    const oscillator = audioContext.createOscillator();
    const gainNode = audioContext.createGain();
    const filter = audioContext.createBiquadFilter();

    oscillator.type = "triangle";
    oscillator.frequency.setValueAtTime(frequency, now);

    filter.type = "lowpass";
    filter.frequency.setValueAtTime(1800, now);

    gainNode.gain.setValueAtTime(0.0001, now);
    gainNode.gain.linearRampToValueAtTime(0.22, now + 0.01);
    gainNode.gain.exponentialRampToValueAtTime(0.1, now + 0.08);
    gainNode.gain.exponentialRampToValueAtTime(0.0001, now + 1.0);

    oscillator.connect(filter);
    filter.connect(gainNode);
    gainNode.connect(audioContext.destination);

    oscillator.start(now);
    oscillator.stop(now + 1.0);
  };

  const handleSkillClick = (index) => {
    const frequency = notes[index % notes.length];
    playPianoTone(frequency);
  };

  return (
    <section className="skills3d-section" data-section="skills">
      <div className="skills3d-shell">
        <div className="skills3d-header">
          <h2 className="skills3d-title">SKILLS</h2>
          <p>(Click on any skill below to hear a piano note.)</p>
        </div>

        <div className="skills3d-console">
          <div className="skills3d-grid">
            {skills.map((skill, index) => (
              <button
                key={skill}
                className="skill3d-tile"
                type="button"
                onClick={() => handleSkillClick(index)}
              >
                <span className="skill3d-face">
                  <span className="skill3d-label">{skill}</span>
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}